const APP = {
	name: 'Национальное Агентство Развития Квалификаций by <a href="https://ibrush.ru">iBrush</a>'
};